<div class="content-container notification-top-margin">
	<div class="content-container-body column spacing-8">
		<div class="row flex-row-style title-row-padding">
			<h3 class="flex-grow-1 notifications-title" i18n="@@notificationPreferences-notifications">Notifications</h3>
			<div class="flex-grow-4">
				<!-- This flex-grow-4 is to make things lineup with the main body of the table-->
				<div class="spacing-24 flex-grow-1"></div>
				@if (this.isEditingNotifications) {
					<div class="spacing-24 flex-grow-1">
						<div class="checkbox-container">
							<span class="header-row-font" i18n="@@notificationPreferences-selectAll">Select All</span>
							<mat-checkbox
								class="checkbox-label-above"
								[disabled]="!isEditingNotifications"
								[checked]="isSelectedAllEmailChecked()"
								[indeterminate]="isSelectAllEmailIntermediate()"
								data-automation-id="select-all-checkbox"
								(change)="onSelectAllEmailToggle($event.checked)"
							></mat-checkbox>
						</div>
					</div>
				}
				@if (this.isEditingNotifications && this.isSmsNotificationEnabled) {
					<div class="spacing-24 flex-grow-1">
						<div class="checkbox-container">
							<span class="header-row-font" i18n="@@notificationPreferences-selectAll">Select All</span>
							<mat-checkbox
								class="checkbox-label-above"
								[disabled]="!isEditingNotifications"
								[checked]="isSelectedAllSmsChecked()"
								[indeterminate]="isSelectAllSmsIntermediate()"
								data-automation-id="select-all-checkbox"
								(change)="onSelectAllSmsToggle($event.checked)"
							></mat-checkbox>
						</div>
					</div>
				}
				@if (this.isEditingNotifications === false) {
					<div class="spacing-24 flex-grow-1 last-column-width">
						<button
							mat-button
							i18n="@@notificationPreferences-edit"
							class="primary-button"
							(click)="isEditingNotifications = true"
							data-automation-id="notification-prefs-edit-button"
						>
							Edit
						</button>
					</div>
				}
				@if (this.isEditingNotifications) {
					<div class="spacing-8 flex-grow-1 flex-row last-column-width">
						<div class="flex-1">
							<button
								mat-button
								i18n="@@notificationPreferences-cancel"
								class="secondary-button"
								(click)="cancelEditing()"
								data-automation-id="notification-prefs-cancel-button"
							>
								Cancel
							</button>
						</div>
						<div class="flex-1">
							<button
								mat-button
								i18n="@@notificationPreferences-saveChanges"
								class="primary-button"
								(click)="saveNotificationPreferences()"
								data-automation-id="notification-prefs-save-changes-button"
							>
								Save Changes
							</button>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<mat-divider></mat-divider>

	<div class="content-container-body column spacing-8">
		<!-- This is the column header row-->
		<div class="row flex-row-style header-row-font header-row-padding">
			<div class="flex-grow-1" i18n="@@notificationPreferences-deviceGroup">Device Group</div>
			<div class="flex-grow-4">
				<!-- This flex-grow-4 is to make things lineup with the main body of the table-->
				<div class="flex-grow-1" i18n="@@notificationPreferences-notification">Notification</div>
				<div class="flex-grow-1">
					<div i18n="@@notificationPreferences-email" class="checkbox-center">Email</div>
				</div>
				@if (this.isSmsNotificationEnabled) {
					<div class="flex-grow-1">
						<div i18n="@@notificationPreferences-sms" class="checkbox-center">SMS</div>
					</div>
				}
				<div class="flex-grow-1 last-width">
					<div i18n="@@notificationPreferences-dashboard" class="checkbox-center">Dashboard</div>
				</div>
			</div>
		</div>
		<!-- This is the main body of the Notifications-->
		<div class="column">
			<!-- Need a loop here to iterate over all the device groups-->
			@for (
				userNotificationPreference of editUserNotificationPreferences;
				track userNotificationPreference.deviceGroupId
			) {
				<div class="row flex-row-style body-row-style">
					@if (userNotificationPreference.deviceGroupName) {
						<div class="flex-grow-1">
							<!-- This has just the device group name -->{{ userNotificationPreference.deviceGroupName }}
						</div>
						<div class="column flex-grow-4">
							<!-- This has the content of each UserDeviceGroupNotificationPreference -->
							<!-- Need a loop here to iterate over all the UserDeviceGroupNotificationPreferences -->
							@for (
								userDeviceGroupNotificationPreference of userNotificationPreference.userDeviceGroupNotificationPreferences;
								track userDeviceGroupNotificationPreference.userNotificationEventTypeId
							) {
								<div class="row flex-row-style preference-sub-row-style">
									<!-- We have to have all the possible types of notifications so we can get translations for them-->
									@if (
										userDeviceGroupNotificationPreference.userNotificationEventType?.nameTranslationKey ===
										'lowBatteryNotification'
									) {
										<div class="flex-grow-1" i18n="@@notificationPreferences-lowBatteryNotification">Low Battery</div>
									}
									@if (
										userDeviceGroupNotificationPreference.userNotificationEventType?.nameTranslationKey ===
										'missingKeyNotification'
									) {
										<div class="flex-grow-1" i18n="@@notificationPreferences-missingKeyNotification">Missing Key</div>
									}
									@if (
										userDeviceGroupNotificationPreference.userNotificationEventType?.nameTranslationKey ===
										'keyNotDetectedNotification'
									) {
										<div class="flex-grow-1" i18n="@@notificationPreferences-keyDetectionStatusNotification">
											Key Detection Status
										</div>
									}
									<div class="flex-grow-1">
										<div class="checkbox-center">
											<mat-checkbox
												[checked]="userDeviceGroupNotificationPreference.receiveEmail"
												[disabled]="!isEditingNotifications"
												[attr.data-automation-id]="
													'user-device-notification-preference-email-' + userDeviceGroupNotificationPreference.id
												"
												(change)="
													userDeviceGroupNotificationPreference.receiveEmail =
														!userDeviceGroupNotificationPreference.receiveEmail
												"
											>
											</mat-checkbox>
										</div>
									</div>
									@if (this.isSmsNotificationEnabled) {
										<div class="flex-grow-1">
											<div class="checkbox-center">
												<mat-checkbox
													[checked]="userDeviceGroupNotificationPreference.receiveSms"
													[disabled]="!isEditingNotifications"
													[attr.data-automation-id]="
														'user-device-notification-preference-sms-' + userDeviceGroupNotificationPreference.id
													"
													(change)="
														userDeviceGroupNotificationPreference.receiveSms =
															!userDeviceGroupNotificationPreference.receiveSms
													"
												>
												</mat-checkbox>
											</div>
										</div>
									}
									<div class="flex-grow-1 last-width">
										<div class="checkbox-center">
											<mat-checkbox
												[attr.data-automation-id]="
													'user-device-notification-preference-other-' + userDeviceGroupNotificationPreference.id
												"
												[checked]="true"
												[disabled]="true"
											>
											</mat-checkbox>
										</div>
									</div>
								</div>
							}
						</div>
					}
				</div>
			}
		</div>
	</div>
</div>
